import requests from "../agent";

const CatalogoGeneral = {
    getValoresCatalogo: (catalogo) => requests.get(`/CatalogoGeneral/GetValoresCatalogo/${catalogo}`),
};

export default CatalogoGeneral;
